'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mask = require('./mask');

var _mask2 = _interopRequireDefault(_mask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _mask2.default; /**
                                   * Created by jf on 15/10/27.
                                   */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/mask/index.js
// module id = 27
// module chunks = 0